document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("part-number-modal");
  const closeBtn = modal?.querySelector(".nso-modal__close");
  const overlay = modal?.querySelector(".nso-modal__overlay");

  const openBtn = document.querySelector("#open-part-number-modal"); 
  // You need an open button somewhere

  if (openBtn && modal) {
    openBtn.addEventListener("click", () => {
      modal.setAttribute("aria-hidden", "false");
    });
  }

  function closeModal() {
    modal.setAttribute("aria-hidden", "true");
  }

  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (overlay) overlay.addEventListener("click", closeModal);
});
